import { atom } from 'recoil';

export const checkList = atom({
  key: 'checkList',
  default: { },
});
